import { CalendarOptions } from "@fullcalendar/common";

export default function getCalendarOptions(
  locale,
  isResponsable,
  nbrExperts,
  scrollToTime,
  onClickNouvelleCampagne,
  onClickGestionCampagnes,
  onClickNouvelleJournee
): CalendarOptions {
  const customButtons = {
    nouvelleCampagne: {
      text: "Nouvelle campagne",
      click: () => onClickNouvelleCampagne(),
    },
    gestionCampagnes: {
      text: "Gestion de campagnes",
      click: () => onClickGestionCampagnes(),
    },
    nouvelleJournee: {
      text: "Nouvelle journée",
      click: () => onClickNouvelleJournee(),
    },
  };
  return {
    initialView: "timeGridWeek",
    locale,
    nowIndicator: false,
    allDaySlot: false,
    contentHeight: window.innerHeight - 200,
    scrollTimeReset: false,
    scrollTime: scrollToTime,
    customButtons: customButtons,
    headerToolbar: {
      //left: "prev,next",
      //center: "title",
      right: "nouvelleCampagne,gestionCampagnes,nouvelleJournee",
    },
    slotLabelFormat: {
      hour: "2-digit",
      minute: "2-digit",
      meridiem: "short",
    },
    slotLabelContent: () => null,
    slotDuration: "01:00:00",
    slotLabelInterval: "01:30",
    views: {
      timeGridWeek: {
        titleFormat: { year: "numeric", month: "long" },
        dayHeaderFormat: { weekday: "long" },
      },
      dayGridMonth: {
        titleFormat: { year: "numeric", month: "long" },
      },
    },
    viewDidMount: () => {
      if (!document) return;

      const fcBtnGroupElCollection =
        document.getElementsByClassName("fc-button-group") || [];
      if (fcBtnGroupElCollection.length > 0) {
        const viewChangeBtnBgElement = document.createElement("div");
        viewChangeBtnBgElement.classList.add("fc-views-button-group-bg");
        fcBtnGroupElCollection[0].appendChild(viewChangeBtnBgElement);
      }

      const fcConfigAgendaBtnElCollection =
        document.getElementsByClassName("fc-configureAgenda-button") || [];
      if (fcConfigAgendaBtnElCollection.length > 0) {
        fcConfigAgendaBtnElCollection[0].innerHTML = `<i class="fas fa-cog"></i>`;
      }
    },
    dayHeaderContent: ({ date, text, isToday, view }) => {
      const fullWeekday = view.calendar.formatDate(date, { weekday: 'long' });
      if(view.type === "dayGridMonth"){
        return {
          html: `<p class="fc-custom-dayheader-weekday">${fullWeekday}</p>`
        }
      }else{
        return {
          html: `
              <p class="fc-custom-dayheader-weekday">
                ${text}
              </p>
              <p class="fc-custom-dayheader-dayofmonth${
                isToday ? " fc-custom-dayheader-dayofmonth-istoday" : ""
              }">
                  ${date.getDate().toString().padStart(2, "0")}
              </p>
              `,
        }
      }
    }
  };
}
